import React from "react";
import Typography from "@/components/shared/Typography";
import Visibility from "@/components/shared/Visibility";
import Button from "@/components/ui/Button";
import NavigationMenu from "@/components/ui/NavigationMenu";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { ListItemProps } from "../types";

function ListItem({
  selectedCategory,
  label,
  description,
  href,
  onMouseEnter = () => {},
  value,
  className,
  ...props
}: ListItemProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const isSelected = value === selectedCategory;

  return (
    <li className={cn("w-full h-full", className, classes)} {...native}>
      <NavigationMenu.Link asChild>
        <Button.Link
          variant="link"
          href={href}
          className={cn(
            "flex-col w-full h-full rounded-r-none",
            isSelected && "bg-accent",
          )}
          aria-label={`Goto ${label} Page`}
          onMouseEnter={() => onMouseEnter(value)}
        >
          <Typography.Small className="text-left text-sm leading-none font-medium w-full">
            {label}
          </Typography.Small>

          <Visibility shouldShow={!!description}>
            <Typography.Small className="text-left text-muted-foreground line-clamp-2 text-sm leading-snug w-full">
              {description}
            </Typography.Small>
          </Visibility>
        </Button.Link>
      </NavigationMenu.Link>
    </li>
  );
}

ListItem.displayName = "ListItem";

export default ListItem;
